<template>
    <form
        @submit.prevent="updatePrices"
        :action="route"
        method="post"
    >
        <div class="divide-y">
            <div class="p-4 space-y-8">
                <div class="space-y-4">
                    <heading-3 class="text-center text-gray-700">Sizes</heading-3>

                    <div class="flex space-x-4 items-center">
                        <div class="w-1/2 sm:w-2/3 text-center font-bold text-gray-800">Name</div>
                        <div class="flex-1 text-center font-bold text-gray-800">Price</div>
                        <div class="flex-1 text-center font-bold text-gray-800">Remove</div>
                    </div>
                    <div
                        v-for="(size, index) in sizes"
                        :key="index"
                        class="space-y-4"
                    >
                        <div class="flex space-x-4 items-center">
                            <div class="w-1/2 sm:w-2/3">
                                <input
                                    class="form-input"
                                    type="text"
                                    v-model="size.name"
                                >
                            </div>
                            <div class="flex-1">
                                <input
                                    class="form-input"
                                    type="text"
                                    v-model="size.amount"
                                >
                            </div>
                            <div class="flex-1">
                                <button
                                    type="button"
                                    v-if="showSizeDeleteButtons"
                                    @click.prevent="deletePrice(size)"
                                    class="p-2 w-full flex justify-center items-center rounded hover:bg-gray-200"
                                >
                                    <icon type="x" class="w-6 h-6 text-gray-600" />
                                </button>
                            </div>
                        </div>
                        <div
                            v-if="form.errors[index]"
                            v-text="form.errors[index]"
                            class="text-red-500 text-center"
                        >
                        </div>
                    </div>



                    <button
                        type="button"
                        @click.prevent="addSize"
                        class="w-full btn btn-gray"
                    >
                        Add Size
                    </button>
                </div>

                <div class="space-y-4">
                    <heading-3 class="text-center text-gray-700">Add Ons</heading-3>

                    <div
                        v-if="showAddOnsHeadings"
                        class="flex space-x-4 items-center"
                    >
                        <div class="w-1/2 sm:w-2/3 text-center font-bold text-gray-800">Name</div>
                        <div class="flex-1 text-center font-bold text-gray-800">Price</div>
                        <div class="flex-1 text-center font-bold text-gray-800">Remove</div>
                    </div>

                    <div
                        v-for="(add_on, index) in addOns"
                        :key="index"
                        class="space-y-4"
                    >
                        <div class="flex space-x-4 items-center">
                            <div class="w-1/2 sm:w-2/3">
                                <input
                                    class="form-input"
                                    type="text"
                                    v-model="add_on.name"
                                >
                            </div>
                            <div class="flex-1">
                                <input
                                    class="form-input"
                                    type="text"
                                    v-model="add_on.amount"
                                >
                            </div>
                            <div class="flex-1">
                                <button
                                    type="button"
                                    @click.prevent="deletePrice(add_on)"
                                    class="p-2 w-full flex justify-center items-center rounded hover:bg-gray-200"
                                >
                                    <icon type="x" class="w-6 h-6 text-gray-600" />
                                </button>
                            </div>
                        </div>
                        <div
                            v-if="form.errors[index]"
                            v-text="form.errors[index]"
                            class="col-span-3 text-red-500 text-center sm:text-left"
                        >
                        </div>
                    </div>


                    <button
                        type="button"
                        @click.prevent="addAddOn"
                        class="w-full btn btn-gray"
                    >
                        Add Add On
                    </button>

                </div>

                <div class="space-y-4">
                    <div class="flex space-x-4 items-center">
                        <div class="w-1/2 sm:w-2/3 ">
                            <div class="font-semibold text-gray-700">Delivery Fee</div>
                        </div>
                        <div class="flex-1">
                            <input
                                class="flex-1 form-input"
                                type="text"
                                v-model="delivery.amount"
                            >
                        </div>
                        <div class="flex-1">
                        </div>
                    </div>

                    <div
                        v-if="form.errors[index]"
                        v-text="form.errors[index]"
                        class="col-span-3 text-red-500 text-center sm:text-left"
                    >
                    </div>
                </div>

            <div class="p-4 flex justify-end items-center space-x-4">
                <loading-button
                    type="submit"
                    class="btn btn-green"
                    :loading="form.processing"
                >
                    Submit
                </loading-button>
            </div>
            </div>
        </div>
    </form>
</template>

<script>
import Icon from './shared/Icon'
import LoadingButton from './shared/LoadingButton'
import Heading3 from './shared/Heading3'
import Form from '@/functions/Form'

export default {
    props: {
        route: {
            type: String,
            required: true,
        },
        prices: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            form: Form({
                prices: this.prices
            })
        }
    },
    computed: {
        sizes() {
            return _.filter(this.form.prices, { type: 'size'})
        },
        addOns() {
            return _.filter(this.form.prices, { type: 'add_on'})
        },
        delivery() {
           return _.find(this.form.prices, { type: 'delivery'})
        },
        showSizeDeleteButtons() {
            return _.size(this.sizes) > 1
        },
        showAddOnsHeadings() {
            return _.size(this.addOns) > 0
        },
    },
    methods: {
        updatePrices() {
            this.form.transform(data => ({...data.prices})).put(this.route, {
                onSuccess: () => alert('here')
            })
        },
        addSize() {
            this.form.prices.push({
                _id: _.uniqueId(),
                type: 'size'
            })
        },
        addAddOn() {
            this.form.prices.push({
                _id: _.uniqueId(),
                type: 'add_on'
            })
        },
        deletePrice(price) {
            _.remove(this.form.prices, price)
        }
    },
    components: {
        Icon,
        Heading3,
        LoadingButton,
    }
}
</script>
